<template>
<div style="border:1px">

<el-form :inline="true"  >
  <el-form-item label="项目名称" >
    <el-input v-model="name" placeholder="项目名称" ></el-input>
  </el-form-item>
   
  <el-table 
    border
  
    :data="unselecteditemlist.filter(data =>  data.GNAME.toLowerCase().indexOf(name.toLowerCase())>=0)"
    reserve-selection="true" 
    row-key="Gid"
     :header-cell-style="{'text-align': 'center'}"
      style="width: 100%" ref="refTable">
   <el-table-column
      width="40%"   >
       <template slot-scope="scope" >
       <el-checkbox v-model="selectedgid[scope.row.Gid]"  @change="CountPrice(scope.row.Gid)" :disabled="disabledgid[scope.row.Gid]" >
       </el-checkbox>
       </template>
    </el-table-column>
   <!--   <el-table-column
      label="序号"  width="55"
       type="index">
    </el-table-column> -->
     <el-table-column
      label="项目名称" width="80%" 
      prop="GNAME">
    </el-table-column>
      <el-table-column
      label="检查意义"
      prop="GRemarks">
    </el-table-column>
     <el-table-column
      label="价格(元)"
      prop="GPrice"   width="60%">
    </el-table-column>
   
  </el-table>
 
  

    </el-form>

        <div id="content"  class="contentDown">
          
            
           <!--   <el-row>
        <el-col :span="4">应收金额:</el-col>
        <el-col :span="8" style="color:red">{{Math.max(Number(this.lZheKouPrice+this.monoidalprice) - Number(this.user.FixedQuota)+Number(this.user.FuWuFei),0).toFixed(2)}}元</el-col>
        <el-col :span="4">折后价格:</el-col>
        <el-col :span="8">{{Math.max(Number(this.lZheKouPrice+this.monoidalprice),0).toFixed(2)}}元</el-col>
        <el-col :span="4">服务费:</el-col>
        <el-col :span="8">{{this.user.FuWuFei}}元</el-col>
        <el-col :span="4">额定金额:</el-col>
        <el-col :span="8">{{parseFloat(this.user.FixedQuota).toFixed(2)}}元</el-col>
               
             </el-row>
              <el-row  class="contentDown2">
               <el-col :span="10"><el-button type="warning"  @click="prestep">上一步</el-button></el-col>
                
               <el-col :span="12" > <el-button type="danger"  @click="nextstep">下一步</el-button></el-col>
                
             </el-row> -->

              <el-row style=" top:50%;">
              <el-col :span="12">应收金额:{{Math.max(Number(this.lZheKouPrice+this.monoidalprice) - Number(this.user.FixedQuota)+Number(this.user.FuWuFei),0).toFixed(2)}}元</el-col>
              <el-col :span="6"><el-button type="warning"  @click="prestep" style="width: 100%;">上一步</el-button></el-col>
              <el-col :span="6"> <el-button type="primary"  @click="nextstep" style="width: 100%;">下一步</el-button></el-col>
               
             </el-row>

         </div>
</div>
</template>

<script>
import {restbase} from '../rest'
import {foowwLocalStorage} from '../rest'
export default {

  data() {
    return {
       name: '',
       loading: false,
        unselecteditemlist: [],//包没有选取的基表2项目列表
        selectedgid: [],//选择的单项基表2项目gid
        lZheKouPrice:0,//折扣价
        monoidalprice:0, //单选基表2折扣价
        itemlist:[],//已选包gid
        disabledgid:[],
        limitCount:0,
        mlimitCount:0,
        user:[],//用户信息
        selectedpkgs:[],//已选包
        ft2:[],//基表2项目
        relation:[],//关系表
        user:[]
        
       
    };
  },
   created(){
           
            //页面加载前执行 获取用户信息
           if (this.user.length == 0) {
               this.user=JSON.parse(foowwLocalStorage.get('user'));
            }
            console.log(this.user);
            this.ft2= JSON.parse(foowwLocalStorage.get('ft2'));//获取所有基表2项目
           this.relation=JSON.parse(sessionStorage.getItem('relation')); //获取所有关系
           console.log(this.relation);
            //判断是否选择了包，获取他的折扣价
            if( sessionStorage.getItem('lZheKouPrice')!=undefined){
               this.lZheKouPrice= JSON.parse(sessionStorage.getItem('lZheKouPrice'));
               this.selectedpkgs= JSON.parse(sessionStorage.getItem('selectedpkgs'));
               
               }
                 //判断是否选择了单项，获取他的折扣价   
               if(sessionStorage.getItem('selectedgid')!=undefined){
                this.monoidalprice=JSON.parse(sessionStorage.getItem('monoidalprice'));
                this.selectedgid= JSON.parse(sessionStorage.getItem('selectedgid'));
                this.disabledgid= JSON.parse(sessionStorage.getItem('disabledgid'));
               }else if(sessionStorage.getItem('oldselectedgid')!=undefined){
                this.selectedgid= JSON.parse(sessionStorage.getItem('oldselectedgid'));
               }
               
        },
    mounted() {
            //显示没有选择的剩余基表2项目
            this.fetchData();
            if(this.selectedgid!=undefined){
                let electedpkgs2;
                 electedpkgs2= this.getselectedpkgs();
                 sessionStorage.setItem('Melectedpkgs2',JSON.stringify(electedpkgs2));
                 //特殊处理CT,不参与折扣
                  let DPrice=0;
               　electedpkgs2.some((item)=>{
　　　　　　　　　　if(item.Gid==540){
　　　　　　　　　　　　DPrice=item.GPrice;
　　　　　　　　　　}
　　　　　　　　})　　　

                const s = electedpkgs2.reduce((prev, item) => item.GPrice + prev, 0)-DPrice;
               
                this.monoidalprice= s * this.user.Discount+DPrice;
                
                 const ar = Object.keys(this.selectedgid).filter(key=>this.selectedgid[key]);
            
                 var newArr = ar.map((item)=> parseInt(item));
               

                 newArr.forEach((item)=>{
                  //互斥关联
                   for(var i=0;i<this.relation.length;i++){
                     var a=this.relation[i].Gid;
                     if (a==item) 
                     {
                       
                        var ExclusionID=this.relation[i].ExclusionID;//互斥字段
                       console.log(ExclusionID);
                        if(ExclusionID!=null){

                          if(ExclusionID.indexOf(',')>0){
                            var num=ExclusionID.split(',');
                            num.forEach(a => {
                              this.$set(this.disabledgid,a,true);
                               console.log(111);
                            })
                          }else{
                            this.$set(this.disabledgid,ExclusionID,true);
                            }
                            }
                     }
                   }
                })

                
               }
              
    },
  methods: {
   fetchData(){
       //获取已选包的GID集合
      
        this.selectedpkgs.forEach(pkg => {
                pkg.GIDs.forEach(g => {
                    if (this.itemlist.indexOf(g) === -1) {
                        this.itemlist.push(g)
                    }
                //选择  CT（胸部） 后，排除： 胸部正位X光片、胸部正侧位X光片、胸部侧位X光片
                if(this.itemlist.indexOf(540)>0 && this.itemlist.indexOf(150)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 150), 1);
                }
                  if(this.itemlist.indexOf(540)>0 && this.itemlist.indexOf(149)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 149), 1);
                }
                if(this.itemlist.indexOf(540)>0 && this.itemlist.indexOf(287)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 287), 1);
                }
                //选择 胸部正侧位X光片后，排除：胸部正位X光片、胸部侧位X光片
                  if(this.itemlist.indexOf(149)>0 && this.itemlist.indexOf(150)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 150), 1);
                }
                 if(this.itemlist.indexOf(149)>0 && this.itemlist.indexOf(287)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 287), 1);
                }
                 if(this.itemlist.indexOf(558)>0 && this.itemlist.indexOf(560)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 558), 1);
                }
                   if(this.itemlist.indexOf(559)>0 && this.itemlist.indexOf(560)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 559), 1);
                }

                });
            });
             //查询已选包中已经有几张X光片
             let electedgids2;
                 electedgids2= this.getselectedgids();
                 this.limitCount=electedgids2.reduce((prev, item) => item.limitCount + prev, 0)
                 
           //列出当前目标疾病下的所有未选项目
           this.ft2.forEach(item => {
             
           if (this.itemlist.indexOf(item.Gid) === -1 && this.unselecteditemlist.indexOf(item) === -1) 
              {
                this.unselecteditemlist.push(item);
               }
             
             });
             //排出包中互斥的单项
             this.relation.forEach(r => {
               if (this.itemlist.indexOf(r.Gid)>=0) 
                  { 

                    for(var i=0;i<this.unselecteditemlist.length;i++){
                      //&&((r.ExclusionID.indexOf(',')>=0 &&r.ExclusionID.indexOf(this.unselecteditemlist[i].Gid+',')>=0)||(r.ExclusionID.indexOf(',')<0 &&r.ExclusionID.indexOf(this.unselecteditemlist[i].Gid)>=0))
                    if (r.ExclusionID!=null) 
                     {
                        var ExclusionID=r.ExclusionID.split(',');
                        if(ExclusionID.indexOf(this.unselecteditemlist[i].Gid+"")>=0)
                        {
                          var i=this.unselecteditemlist.indexOf(this.unselecteditemlist[i]);
                          this.unselecteditemlist.splice(i--,1);//非常重要，删除指定坐标后，数组改变
                        }
                    }
                    }
                  
                  }
                 })

                 
                 
        },
  
  
    CountPrice(gid){
                   var ischecked=this.selectedgid[gid];//判断勾选状态
                   //互斥关联
                   for(var i=0;i<this.relation.length;i++){
                     var a=this.relation[i].Gid;
                     
                     if (a==gid) 
                     {
                        var ExclusionID=this.relation[i].ExclusionID;//互斥字段
                        var LinkID=this.relation[i].LinkID;//关联字段
                       
                        //处理关联项目
                        if(LinkID!=null){
                          if(LinkID.indexOf(',')>0){
                            var num=LinkID.split(',');
                            num.forEach(item => {
                             if(this.itemlist.find(obj => obj == item)==undefined)
                             if(item==135&&!ischecked){
                              var relationxue=this.relation.filter((arr) => arr.LinkID==135);
                              var a=relationxue.map(function (item) {return item['Gid'] }); 
                              var b=this.getselectedpkgs().filter((arr) => a.indexOf(arr.Gid)>=0);
                               if(b.length<=0){
                              this.$set(this.selectedgid,item,ischecked);
                              this.$set(this.disabledgid,item,ischecked);
                              }
                             }else{
                              this.$set(this.selectedgid,item,ischecked);
                              this.$set(this.disabledgid,item,ischecked);
                              }
                            })
                          }else{
                            if(this.itemlist.find(obj => obj == LinkID)==undefined)
                             if(LinkID==135&&!ischecked){
                               
                              
                              var relationxue=this.relation.filter((arr) => arr.LinkID==135);
                              var a=relationxue.map(function (item) {return item['Gid'] }); 
                              var b=this.getselectedpkgs().filter((arr) => a.indexOf(arr.Gid)>=0);
                             
                              if(b.length<=0){
                            this.$set(this.selectedgid,LinkID,ischecked);
                            this.$set(this.disabledgid,LinkID,ischecked);
                              }
                             }else{
                            this.$set(this.selectedgid,LinkID,ischecked);
                            this.$set(this.disabledgid,LinkID,ischecked);
                            }
                            }
                         
                        }
                        //处理互斥
                        if(ExclusionID!=null){

                          if(ExclusionID.indexOf(',')>0){
                            var num=ExclusionID.split(',');
                            num.forEach(item => {
                              this.$set(this.disabledgid,item,ischecked);
                            })
                          }else{
                            this.$set(this.disabledgid,ExclusionID,ischecked);
                            }
                            }

                     }

                    }
                //计算价格
                 let electedpkgs2;
                 electedpkgs2= this.getselectedpkgs();
                 sessionStorage.setItem('Melectedpkgs2',JSON.stringify(electedpkgs2));
                 this.mlimitCount=electedpkgs2.reduce((prev, item) => item.limitCount + prev, 0)
                 
                 //特殊处理CT,不参与折扣
                  let DPrice=0;
               　electedpkgs2.some((item)=>{
　　　　　　　　　　if(item.Gid==540){
　　　　　　　　　　　　DPrice=item.GPrice;
　　　　　　　　　　}
　　　　　　　　})　　　


                const s = electedpkgs2.reduce((prev, item) => item.GPrice + prev, 0)-DPrice;
               
                this.monoidalprice= s * this.user.Discount+DPrice;
                //X光超'过五张提醒
                if(ischecked){
                  let ms='';
                if(((gid>=149 &&gid<=159)||(gid==171||gid==252||gid==253||gid==287))&&this.limitCount+this.mlimitCount>4){
                   ms+='X片不建议超过4张!'
                }
                if(this.user.Sex=='女' && (gid==147 ||gid==148||gid==148||gid==491||gid==499)){
                 
                    ms+=' 无性生活及3个月内做过妇科检查或治疗不建议查!'
                 }
                 console.log(this.user.Sex);
                 if(this.user.Sex=='女' &&((gid>=149 &&gid<=159) ||gid==252||gid==253||gid==287||gid==540||gid==171||gid==527||gid==125||gid==176|| (gid>=557 && gid<=560) || gid ==564 || gid==565||gid==608)){
                    ms+=' 孕期及哺乳期女性不建议检查!'
                 }
                  if(ms!=''){
                    
                      this.$notify.warning({
                            title: '提醒',
                            message: ms,
                             offset: 150,
                             duration:0,
                              position: 'top-left'
                        });
                         
                 }

                }

             },
    getselectedpkgs() {
                //对象转数组并过滤出已点选的key
                const ar = Object.keys(this.selectedgid).filter(key=>this.selectedgid[key]).filter(function (s) {
    return s && s.trim(); 
});
            
                 var newArr = ar.map((item)=> parseInt(item))
             
                 sessionStorage.setItem('Mgids',JSON.stringify(newArr));
                //将已选择的gid数组转换成基表二数组
                  return ar.map(v=>
                    this.unselecteditemlist.find(p=>
                        String(p.Gid) === v
                    )
                ).filter(key=>key!=undefined);
                
            },
             getselectedgids() {
               
                //将已选择的gid数组转换成基表二数组
                  return this.itemlist.map(v=>
                    this.ft2.find(p=>
                        p.Gid === v
                    )
                )
                
            },
           prestep() {
               //上一步 存储已选价格
                sessionStorage.setItem('monoidalprice',JSON.stringify(this.monoidalprice));
                sessionStorage.setItem('monoidalList',JSON.stringify(this.getselectedpkgs()));
                sessionStorage.setItem('selectedgid',JSON.stringify(this.selectedgid));
                sessionStorage.setItem('disabledgid',JSON.stringify(this.disabledgid));
                this.$router.push('disease');
            }, 
            nextstep() {
               //下一步 存储已选价格
                this.$http.post(restbase() + "asp/SetTSPKTarget_new", {
                    SFZH: this.user.PaperValue,
                    TargetIDs: JSON.parse(sessionStorage.getItem('Mgids')),
                     type:2
                }).then((response) => {
                     sessionStorage.setItem('monoidalprice',JSON.stringify(this.monoidalprice));
               sessionStorage.setItem('monoidalList',JSON.stringify(this.getselectedpkgs()));
               sessionStorage.setItem('selectedgid',JSON.stringify(this.selectedgid));
               sessionStorage.setItem('disabledgid',JSON.stringify(this.disabledgid));
               this.$router.push('order');
                    console.log(response);
                }, (response) => {
                    console.log(response);
                }).catch((response) => {
                    console.log(response);
                });
            
            }

}
}

</script>

<style scoped>
.el-table {
  width: 100%;
}
     .contentDown {
        font-size: 14px;
        bottom:0px;
        overflow:visible;
        position:fixed;
        z-index: 999;
        text-align:center;
        overflow:hidden;
        width:100%;
     
        line-height:35px;
        padding:0;
        color:white;
        background-color:#99a9bf;
        
    }
      .contentDown2 {
        font-size: 14px;
        color:white;
        text-align:center;
    }
    .next {
        font-size: 14px;
        width:1000px;
        height:48px;
        line-height:48px;
        padding:0; 
    }
       .tdstop {
        width:100%;
        height:48px;
        line-height:48px;
        padding:0;
        color:white;
        background-color:#80A0D0;
        border-radius:4px 4px 0 0;
        margin-bottom:10px;
      
    }
      .pepkgframe {
        margin:0 auto;
        width:100%;
        padding-bottom:26px;
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
        border-radius: 4px;
        box-shadow: 2px 2px 2px #888;
        background-color: white;
        margin-bottom: 10px;
    }
</style>